/*HISTORY 1.5.0*/
if(typeof window.console==="undefined"){window.console={}}if(typeof window.console.emulated==="undefined"){if(typeof window.console.log==="function"){window.console.hasLog=true}else{if(typeof window.console.log==="undefined"){window.console.log=function(){}}window.console.hasLog=false}if(typeof window.console.debug==="function"){window.console.hasDebug=true}else{if(typeof window.console.debug==="undefined"){window.console.debug=!window.console.hasLog?function(){}:function(){var a=["console.debug:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a)}}window.console.hasDebug=false}if(typeof window.console.warn==="function"){window.console.hasWarn=true}else{if(typeof window.console.warn==="undefined"){window.console.warn=!window.console.hasLog?function(){}:function(){var a=["console.warn:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a)}}window.console.hasWarn=false}if(typeof window.console.error==="function"){window.console.hasError=true}else{if(typeof window.console.error==="undefined"){window.console.error=function(){var c="An error has occured.";if(window.console.hasLog){var a=["console.error:"];for(var b=0;b<arguments.length;b++){a.push(arguments[b])}window.console.log.apply(window.console,a);c="An error has occured. More information is available in your browser's javascript console."}for(var b=0;b<arguments.length;++b){if(typeof arguments[b]!=="string"){break}c+="\n"+arguments[b]}if(typeof Error!=="undefined"){throw new Error(c)}else{throw (c)}}}window.console.hasError=false}if(typeof window.console.trace==="function"){window.console.hasTrace=true}else{if(typeof window.console.trace==="undefined"){window.console.trace=function(){window.console.error("console.trace does not exist")}}window.console.hasTrace=false}window.console.emulated=true}(function(a){if(!(a.History||false)){a.History={options:{debug:false},state:"",$window:null,$iframe:null,handlers:{generic:[],specific:{}},extractHash:function(b){var c=b.replace(/^[^#]*#/,"").replace(/^#+|#+$/,"");return c},getState:function(){var b=a.History;return b.state},setState:function(c){var b=a.History;c=b.extractHash(c);b.state=c;return b.state},getHash:function(){var b=a.History;var c=b.extractHash(window.location.hash||location.hash);return c},setHash:function(c){var b=a.History;c=b.extractHash(c);if(typeof window.location.hash!=="undefined"){if(window.location.hash!==c){window.location.hash=c}}else{if(location.hash!==c){location.hash=c}}return c},go:function(e){var b=a.History;e=b.extractHash(e);var d=b.getHash(),c=b.getState();if(e!==d){b.setHash(e)}else{if(e!==c){b.setState(e)}b.trigger()}return true},hashchange:function(d){var b=a.History;var c=b.getHash();b.go(c);return true},bind:function(d,b){var c=a.History;if(b){if(typeof c.handlers.specific[d]==="undefined"){c.handlers.specific[d]=[]}c.handlers.specific[d].push(b)}else{b=d;c.handlers.generic.push(b)}return true},trigger:function(f){var d=a.History;if(typeof f==="undefined"){f=d.getState()}var b,g,c,e;if(typeof d.handlers.specific[f]!=="undefined"){e=d.handlers.specific[f];for(b=0,g=e.length;b<g;++b){c=e[b];c(f)}}e=d.handlers.generic;for(b=0,g=e.length;b<g;++b){c=e[b];c(f)}return true},construct:function(){var b=a.History;a(document).ready(function(){b.domReady()});return true},configure:function(b){var c=a.History;c.options=a.extend(c.options,b);return true},domReadied:false,domReady:function(){var b=a.History;if(b.domRedied){return}b.domRedied=true;b.$window=a(window);b.$window.bind("hashchange",this.hashchange);setTimeout(b.hashchangeLoader,200);return true},nativeSupport:function(b){return true},hashchangeLoader:function(){var c=a.History;var f=c.nativeSupport();if(!f){var b;if(a.browser.msie){c.$iframe=a('<iframe id="jquery-history-iframe" style="display: none;"></$iframe>').prependTo(document.body)[0];c.$iframe.contentWindow.document.open();c.$iframe.contentWindow.document.close();var e=false;b=function(){var i=c.getHash();var h=c.getState();var g=c.extractHash(c.$iframe.contentWindow.document.location.hash);if(h!==i){if(!e){c.$iframe.contentWindow.document.open();c.$iframe.contentWindow.document.close();c.$iframe.contentWindow.document.location.hash=i}e=false;c.$window.trigger("hashchange")}else{if(h!==g){e=true;c.setHash(g)}}}}else{b=function(){var h=c.getHash();var g=c.getState();if(g!==h){c.$window.trigger("hashchange")}}}setInterval(b,200)}else{var d=c.getHash();if(d){c.$window.trigger("hashchange")}}return true}};a.History.construct()}else{window.console.warn("$.History has already been defined...")}})(jQuery);

www.pageType='account';

function currentAgreements(){
	$('#old-permissions input').click(function(){
		$('#old-permissions').addClass('loading');
		setTimeout(function(){
			$('#old-permissions').remove();
			$('#agreements-form').removeClass('old-mode');
		},1000);
	});
}

function orderEmailValid(){
	if (!isAnyUserLogged()) {
		loadingStart();
		location.href='/customer-current-orders.bhtml';
		return false;
	}
	if($('#F_SENDER_COMMENT').val().length>3){
		$('#trescBox').removeClass('statusError');
		$('#trescdiv').hide();
		$('#F_ACTION').val('SEND');
		$('#frontForm .buttons').text('wysyłanie...');
		$('#frontForm').ajaxSubmit({
			target: '#fancybox-content .errorForm',
			success:function(html){

			},
			error:function(){
				app.alert('Błąd wysyłania danych');
			}
		});
	}
	else{
		$('#trescdiv').show();
		$('#trescBox').addClass('statusError');
	}
}

function orderEmailBack() {
	$('#frontForm').submit();
	return false;
}




function ankietaTracker(){
	UA.pageview('/akcje/konto-klienta/zamowienia-historyczne/akcje-rekomendowane/ocen-zakupy');
}
function courierTrackingUA(view,order,status){
	UA.interaction('Konto Klienta','Zamówienia','Lokalizuj przesyłkę');
	app.logEvent({
		'id': 'parceltracker',
		'f03': order,
		'f04': status,
		'f05': view
	});
}
function accountUpdateSlectedDeliveryTimeInterval(value, guestLogged){
	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url: guestLogged ? '/guest-order-delivery-time.ltr' : '/customer-order-delivery-time.ltr',
		cache: false,
		dataType:'json',
		data: {
			'ACTION':'SELECT_INTERVAL',
			selected_interval: value
		},
		success: function(json){
			if(value==0){
				$('#row4').show();
				$('#row3').hide();
			}else{
				$('#deliveryPrice').html(json.mainOrderDeliveryPrice);
				$('#delivery-with-own-payment-price').html(json.mainOrderDeliveryWithOwnPayment);
				$('#row3').show();
				$('#row4').hide();
			}
		}
	});
}

function customerOrderEdit(orderNumber){

	if ($('#message').length) {
		$.fancybox({
			href			: '#message'
		}, {
			autoDimensions:true
		});
	}
	clickZmienAnuluj('email');
	clickZmienAnuluj('dane');
	clickZmienAnuluj('customer');
	clickZmienAnuluj('invoiceAddress');
	clickZmienAnuluj('payment');

	$('#delivery-time-zmien').click(function(){
		$.ajax({
			url:'/customer-order-delivery-time.ltr?orderNumber='+$('#order_num').val(),
			success: function(html){
				$('#delivery-timeBox .cc').html(html);
				checkbox('#delivery-timeBox .cc');
				showDeliveryTimeCalendar('.zmien_termin');
			}
		});
		$('#delivery-timeBox').show('fast');
		$(this).hide();
	});

	$(".zipCode").mask2("99-999");
	$(".zipCode").keyfilter(/[\d\-]/);
	nip();
	$(".pesel").mask2("99999999999");
	$(".pesel").keyfilter(/[\d]/);
	$('#emailForm').validate({
		rules: {
			"newEmail": {
				required:true,
				email:true
			},
			"newEmailRepeat":{
				required:true,
				email:true,
				equalTo: "#newEmail"
			}
		},
		messages: {
			"newEmail": {
				required:"Wpisz adres e-mail",
				email:"Wpisz poprawny adres e-mail"
			},
			"newEmailRepeat":{
				required:"Powtórz adres e-mail",
				email:"Powtórz poprawny adres e-mail",
				equalTo: "Podane adresy nie są identyczne"
			}
		}
	});

	autocompleteDelivery('homeZipCode', 'homeCityName');
	autocompleteDelivery('deliveryZipCode', 'deliveryCityName', 'deliveryAddressStreet');
	autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');

	$('#homeAddressForm').validate({
		rules: {
			"newHomeAddress.zipCode":{
				required:true,
				zipCode:true
			},
			"newHomeAddress.city":{
				required: true,
				maxlength: 60,
				city:true
			},
			"newHomeAddress.street": {
				maxlength: 60,
				required: true
			},
			"newHomeAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"newHomeAddress.flatNumber": {
				maxlength: 10,
				flat: true
			}
		},
		messages: {
			"newHomeAddress.zipCode":{
				required:"Podaj kod pocztowy"
			},
			"newHomeAddress.city":{
				required:"Podaj nazwę miejscowości"
			},
			"newHomeAddress.street":{
				required:"Podaj ulicę"
			},
			"newHomeAddress.houseNumber":{
				required:"Podaj numer"
			}
		}
	});
	$('#deliveryAddressForm').validate({
		rules: {
			"newDeliveryAddress.zipCode":{
				required:true,
				zipCode:true
			},
			"newDeliveryAddress.city":{
				required: true,
				maxlength: 40,
				city: true
			},
			"newDeliveryAddress.street": {
				required: true,
				minlength: 2,
				maxlength: 60
			},
			"newDeliveryAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"newDeliveryAddress.flatNumber": {
				maxlength: 10,
				flat: true
			}
		},
		messages: {
			"newDeliveryAddress.zipCode":{
				required:"Podaj kod pocztowy"
			},
			"newDeliveryAddress.city":{
				required: "Podaj nazwę miejscowości",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"newDeliveryAddress.street":{
				required: "Podaj ulicę",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"newDeliveryAddress.houseNumber":{
				required: "Podaj numer",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"newDeliveryAddress.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			}
		}
	});
}

function clickZmienAnuluj(name){
	clickZmien(name);
	clickAnulij(name);
}

function clickZmien(name){
	$('#'+name+'-zmien').click(function(){
		$('.orderBox').not('#'+name+'Box').hide('fast');
		$('a[id*="-anuluj"]').not('#'+name+'-anuluj').click();
		$('#'+name+'Box').show('fast');
		$('#'+name+'-anuluj').show();
		$(this).hide();
	});
}
function clickAnulij(name){
	$('#'+name+'-anuluj').click(function(){
		$('#'+name+'Box').hide('fast');
		$('#'+name+'-zmien').show();
		$(this).hide();
	});
}

function addressSaveGo(formId, target, id){
	loadingStart();
	$(formId+' .zapisz2 ').hide();
	var options = {
		complete: function (response) {
			$('#' + target).html(response.responseText);
			loadingStop();
		}
	};
	$(formId).ajaxForm(options);
	$(formId).submit();
}

function eArchiveHint() {
	$('.eArchiveHelp').mouseover(function(){
		showToolBox(this,$('#eArchiveHint'+jQuery(this).attr('rel')+':eq(0)').html(),165);
	}).mouseleave(function(){
		closeToolBox();
	});
}

function gaTrackReciptFormErrors(){
	if($('#receiptForm .errorBox').hasClass('statusError')){
		UA.pageview('/akcje/konto-klienta/rejestracja-parogonow/porazka');
	}
}

function savedComparisonStart() {
	$('#menu-clipboard-sub').show().parent().addClass('has-children');
	$('#clipboard_compared').parent().addClass('active');
}

function passwordFormValidate() {

	$('#passwordForm').validate({
		rules: {
			"emailNew": {
				required: true,
				email: true
			},
			"emailNewRepeat": {
				required: true,
				email: true,
				equalTo: "#emailNew"
			}
		},
		messages: {
			"emailNew": {
				required: "Wpisz adres e-mail",
				email: "Wpisz poprawny adres e-mail"
			},
			"emailNewRepeat": {
				required: "Powtórz adres e-mail",
				email: "Powtórz poprawny adres e-mail",
				equalTo: "Podane adresy nie są identyczne"
			}
		}
	});
	if ($('#customerForm .statusError').length) $('#customer-zmien').click();
	if ($('#passwordForm .statusError').length) $('#password-zmien').click();
	if ($('#daneBox .statusError').length) $('#dane-zmien').click();

}

function redirectToNkl(applicationId) {
	if (applicationId) {
		loadingStart();
		document.location.href = '/raty/' + applicationId;
	} else {
		app.alert('Błąd wewnętrzny systemu.');
	}
}

function validateDeleteAccount() {
	$('#removeAccountForm').validate({
		rules: {
			"confirmDeleteAccount": "required"
		},
		messages: {
			"confirmDeleteAccount": "Usunięcie konta wymaga potwierdzenia"
		}
	});
};


function actionBlocked(id) {
	if(id){
		fancyOk($('.blockedMessage-'+id).html());
	}
}

function getLinks(){
	var links = "";
	$("input.zaznacz:checked").each(function (i) {
			links += '<'+'div>'+$("#mail_description_"+$(this).val()).html()+"<"+"/div>";
      });
    return links;
}
function aBoxClose(id){
	if(id=='')$('.aBox').hide();
	else $('.aBox').not('#'+id).hide('fast');

	$('.zmienB').show();
	$('.anulujB').hide();
}

function addressSave(formId, target,id) {

	if (showLoginViewIfLogout()) {
		return false;
	}

	if($(formId).valid()){
		loadingStart();
		app.validateAddressIntegrity({
			city: $('#cityName'+id).val(),
			zipCode: $('#zipCode'+id).val(),
			street: $('#street'+id).val()
		})
			.then(data => {
				loadingStop();
				var message = data.message;

				if (message != "") {
					if(!data.blockPaymentStep) {
						showModalAddressError(data, function(){
							addressSaveGo(formId, target, id);
						});
					} else {
						showModalBlockPayment(data);
					}
				}
				else {
					addressSaveGo(formId, target, id);
				}
			});
	}
}
function invoiceDeliveryValidate(id, o){
	if (id != '' && id != null) {
		$('#'+id+' .errorBox').errorBox();
		$('#'+id+' .zipCode').mask2("99-999");
		autocompleteDelivery('zipCode'+o, 'cityName'+o, 'street'+o);
		$('#' + id + ' .nip').keyfilter(/[\d\-]/);
		companyName('company-name-' + o);
		var ID=id.substr(12);
		checkbox('#'+id);
		$('#'+id).validate({
			rules: {
				"firstName": {
					required: true,
					minlength: 2,
					firstname:true
				},
				"addLine1": {
					required:true,
					firstname:true
				},
				"surname":{
					required: true,
					minlength: 2,
					surname:true
				},
				"addLine2":{
					required:true,
					surname:true
				},
				"companyName":{
					required: true,
					maxlength: 160,
					companyName: true
				},
				"phone":{
					phone: true,
					required: true
				},
				"nip":{
					nip: true
				},
				"zipCode":{
					required: true,
					zipCode: true
				},
				"city":{
					required: true,
					minlength: 2,
					maxlength: 40,
					city: true
				},
				"street":{
					required: true,
					minlength: 2,
					maxlength: 60,
					street: true
				},
				"houseNumber":{
					required: true,
					maxlength: 10,
					houseNumber: true
				},
				"flatNumber": {
					maxlength: 10,
					flat: true
				}
			},
			messages: {
				"firstName":{
					required: "Podaj imię",
					minlength: "Imię jest za krótkie"
				},
				"addLine1":{
					required:"Podaj imię"
				},
				"surname":{
					required: "Podaj nazwisko",
					minlength: "Nazwisko jest za krótkie"
				},
				"addLine2":{
					required:"Podaj nazwisko"
				},
				"companyName":{
					required: "Podaj nazwę firmy",
					maxlength: "Pole może zawierać maksymalnie 160 znaków"
				},
				"phone": {
					minlength: "Podaj numer telefonu",
					required: "Podaj poprawny numer telefonu"
				},
				"nip":{
					nip:"Podaj poprawny NIP"
				},
				"zipCode":{
					required:"Podaj kod pocztowy"
				},
				"city":{
					required: "Podaj nazwę miejscowości",
					minlength: "Miasto jest za krótkie",
					maxlength: "Pole może zawierać maksymalnie 40 znaków"
				},
				"street":{
					required: "Podaj ulicę",
					minlength: "Ulica jest za krótka",
					maxlength: "Pole może zawierać maksymalnie 60 znaków"
				},
				"houseNumber":{
					required: "Podaj numer",
					maxlength: "Pole może zawierać maksymalnie 10 znaków"
				},
				"flat": {
					maxlength: "Pole może zawierać maksymalnie 10 znaków"
				}
			}
		});
		regon({
			$box: $('#invoiceDataForm_'+o+' .regon-box'),
			$nip: $('#nip'+o),
			$companyName: $('#company-name-'+o+'-textarea-div'),
			$city: $('#cityName'+o),
			$street: $('#street'+o),
			$houseNumber: $('#homeAddressHouseNumber'+o),
			$flatNumber: $('#homeAddressFlatNumber'+o),
			$zipCode: $('#zipCode'+o)
		});
		if (document.location.hash.indexOf('#edit-') == 0) {
			$('#' + id).valid();
		}
	}
}

function daneBoxSubmitGo(){
	$('#daneBox .zmien').hide();
	$('#daneBox .smallLoading').show();
	$('#frontForm').submit();
}
function passwordStartCommon() {

	if (app.isUpsellingContextActive() && $('.user-data-changed-message').length) {
		location.href = app.getUpsellingUrl();
	}

	$('#password-zmien').click(function () {
		aBoxClose('passwordBox');
		$('#passwordBox').show('fast');
		$('#password-anuluj').show();
		$(this).hide();
	});
	$('#password-anuluj').click(function () {
		$('#passwordBox').hide('fast');
		$('#password-zmien').show();
		$(this).hide();
	});
	$('#customer-zmien').click(function () {
		aBoxClose('customerBox');
		$('#customerBox').show('fast');
		$('#customer-anuluj').show();
		$(this).hide();
	});
	$('#customer-anuluj').click(function () {
		$('#customerBox').hide('fast');
		$('#customer-zmien').show();
		$(this).hide();
	});
	$('#delete-zmien').click(function () {
		aBoxClose('deleteBox');
		$('#deleteBox').show('fast');
		$('#delete-anuluj').show();
		$(this).hide();
	});
	$('#delete-anuluj').click(function () {
		$('#deleteBox').hide('fast');
		$('#delete-zmien').show();
		$(this).hide();
	});
	$('#dane-zmien').click(function () {
		aBoxClose('daneBox');
		$('#daneBox').show('fast');
		$('#dane-anuluj, #dane-anuluj-2').show();
		$(this).hide();
	});
	$('#dane-anuluj, #dane-anuluj-2').click(function () {
		$('#daneBox').hide('fast');
		$('#dane-zmien').show();
		$('#dane-anuluj, #dane-anuluj-2').hide();
	});
	$('#clear-adress-data').click(function () {
		$('#zipCode, #cityName, #street, #homeAddressHouseNumber, #homeAddressFlatNumber').each(function () {
			$(this).val('').trigger('input');
			$(this).parent().siblings('.error').remove();
			$(this).closest('.errorBox').removeClass('statusError');
		});
	});

	//if($('#cityName').val()=='' && $('#zipCode').val()=='')$('.mL124 .zmien').addClass('zatwierdz').removeClass('zmien');
	$("#zipCode").mask2("99-999");
	$("#pesel").mask2("99999999999");
	autocompleteDelivery('zipCode', 'cityName', 'street');
	
	toggleUserTypeAccount();
	$('.nip').keyfilter(/[\d\-]/);
	$("#realPhoneInput").keyfilter(/[\d\- ]/);
	$('#daneBox #frontForm').validate({
		rules: {
			"firstName": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"frontUserType": {
				required: true
			},
			"homeAddress.zipCode": {
				zipCode: true
			},
			"phone": {
				phone: true
			},
			"homeAddress.city": {
				minlength: 2,
				maxlength: 40,
				city: true
			},
			"homeAddress.street": {
				minlength: 2,
				maxlength: 60,
				street: true
			},
			"nip": {
				nip: true
			},
			"companyName": {
				required: true,
				maxlength: 160,
				companyName: true
			},
			"homeAddress.houseNumber": {
				maxlength: 10,
				houseNumber: true
			},
			"homeAddress.flatNumber": {
				maxlength: 10,
				flat: true
			}
		},
		messages: {
			"firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"frontUserType": {
				required: "Wybierz sposób zakupów"
			},
			"homeAddress.zipCode": {
				required: "Podaj kod pocztowy"
			},
			"homeAddress.city": {
				required: "Podaj miejscowość",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"phone": {
				required: "Podaj numer telefonu"
			},
			"homeAddress.street": {
				required: "Podaj ulicę",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"companyName": {
				required: "Podaj nazwę firmy",
				maxlength: "Pole może zawierać maksymalnie 160 znaków"
			},
			"homeAddress.houseNumber": {
				required: "Podaj numer",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"homeAddress.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			}

		}
	});
	companyName('company-name');
	regon({
		$box: $('#companyBox .regon-box'),
		$nip: $('#nip'),
		$companyName: $('#company-name-textarea-div'),
		$city: $('#cityName'),
		$street: $('#street'),
		$houseNumber: $('#homeAddressHouseNumber'),
		$flatNumber: $('#homeAddressFlatNumber'),
		$zipCode: $('#zipCode')
	});
	passwordFormValidate();
	passwordInvalid.init($('#passwordNew'), $('#passwordNew').parents().find('.password-invalid'), $('#passwordNew').closest('.row'), $('#email-hidden'));
	$('#customerForm').validate({
		rules: {
			"passwordNew": {
				strongPassword: true
			},
			"passwordOld": "required",
			"passwordNewRepeat": {
				required: true,
				equalTo: "#passwordNew"
			}
		},
		messages: {
			"passwordOld": "Podaj swoje hasło",
			"passwordNewRepeat": {
				required: "Powtórz nowe hasło",
				equalTo: "Hasła muszą być identyczne"
			}
		}
	});
	if ($('#daneBox span.error').length || document.location.hash == '#data-edit') {
		$('#dane-zmien').click();
		$('#daneBox form').valid();
	}
}

function daneBoxSubmit(){
	if($('#frontForm').valid()){
		if($('#zipCode').val()!='' || $('#zipCode').val()!=''){
			loadingStart();
			app.validateAddressIntegrity({
				city: $('#cityName').val(),
				zipCode: $('#zipCode').val(),
				street: $('#street').val()
			})
				.then((data) =>{
					loadingStop();
					var message = data.message;

					if (message != "") {
						if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){
								daneBoxSubmitGo();
							});
						} else {
							showModalBlockPayment(data);
						}
					}
					else {
						daneBoxSubmitGo();
					}
				});

		}else{
			daneBoxSubmitGo();
		}
	}
}

function removeInvoiceAddressConfirm(addressId) {
	var confirmMessage = 'Czy na pewno chcesz usunąć wskazany adres?';
	$.fancybox('<div class="w300"><div>'+confirmMessage+'</div><div class="mT10 buttonA"><div class="w190"><a class="tak fleft btn btn-second" href="javascript:void(0);" onclick="removeInvoiceAddress(\''+addressId+'\');">Tak</a><a class="nie fleft btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Nie</a><div class="clear"></div></div></div></div>',{autoDimensions:true,hideOnOverlayClick:false});
}
function removeInvoiceAddress(addressId) {
	loadingStart();
	$.ajax({
		url : '/customer-remove-invoice-address.ltr',
		type : 'POST',
		cache : false,
		data: {
			addressId: addressId
		},
		success: function(){
			$.fancybox.close();
			location.reload();
		},
		error: function () {
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			});
		}
	});
}

// moje dane / adres dostawy
function removeDeliveryAddressConfirm(addressId) {
	var confirmMessage = 'Czy na pewno chcesz usunąć wskazany adres?';
	$.fancybox('<div class="w300"><div>'+confirmMessage+'</div><div class="mT10 buttonA"><div class="w190"><a class="tak fleft btn btn-second" href="javascript:void(0);" onclick="removeDeliveryAddress(\''+addressId+'\');">Tak</a><a class="nie fleft btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Nie</a><div class="clear"></div></div></div></div>',{autoDimensions:true,hideOnOverlayClick:false});
}

function removeDeliveryAddress(addressId) {
	loadingStart();
	$.ajax({
		url : '/customer-remove-delivery-address.ltr',
		type : 'POST',
		cache : false,
		data: {
			addressId: addressId
		},
		success: function(){
			$.fancybox.close();
			location.reload();
		},
		error: function(){
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			 });
		}
	});
}
function setDefaultInvoiceAddress(addressId) {
	loadingStart();
	$.ajax({
		url : '/customer-set-default-invoice-address.ltr',
		type : 'POST',
		cache : false,
		data: {
			addressId: addressId
		},
		success: function(){
			$.fancybox.close();
			location.reload();
		},
		error: function(){
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			});
		}
	});
}
function setDefaultDeliveryAddress(addressId) {
	loadingStart();
	$.ajax({
		url : '/customer-set-default-delivery-address.ltr',
		type : 'POST',
		cache : false,
		data: {
			addressId: addressId
		},
		success: function(){
			$.fancybox.close();
			location.reload();
		},
		error: function(){
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			});
		}
	});
}

// moje dane / dane odbiorcy
function removeReceiverDataConfirm(receiverDataId) {
	var confirmMessage = 'Czy na pewno chcesz usunąć wskazane dane odbiorcy?';
	$.fancybox('<div class="w300"><div>'+confirmMessage+'</div><div class="mT10 buttonA"><div class="w190"><a class="tak fleft btn btn-second" href="javascript:void(0);" onclick="removeReceiverData(\''+receiverDataId+'\');">Tak</a><a class="nie fleft btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Nie</a><div class="clear"></div></div></div></div>',{autoDimensions:true,hideOnOverlayClick:false});
}

function removeReceiverData(receiverDataId) {
	loadingStart();
	$.ajax({
		url : '/customer-remove-receiver-data.ltr',
		type : 'POST',
		cache : false,
		data: {
			receiverDataId: receiverDataId
		},
		success: function(html){
			$.fancybox.close();
			location.reload();
		},
		error: function(){
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			});
		}
	});
}

function setDefaultReceiverData(receiverDataId) {
	loadingStart();
	$.ajax({
		url : '/customer-set-default-receiver-data.ltr',
		type : 'POST',
		cache : false,
		data: {
			receiverDataId: receiverDataId
		},
		success: function(){
			$.fancybox.close();
			location.reload();
		},
		error: function(){
			fancyOkCallback('Wystąpił błąd komunikacji, prosimy spróbować później', function () {
				loadingStart();
				location.reload();
			});
		}
	});
}

function saveReceiverData(formId) {
	if (showLoginViewIfLogout()) {
		return false;
	}
	if($(formId).valid()){
		saveReceiverDataSuccess(formId);
	}
}

function saveReceiverDataSuccess(formId){
	var $target = $(formId).closest('.receiverData');
	var options = {
		success: function(responseText){
			if($(responseText).find('.error').length == 0){
				location.reload();
			}
			else{
				$target.html(responseText);
			}
		}
	};

	$(formId+' .smallLoading ').show();
	$(formId+' .zapisz2 ').hide();
	$(formId).ajaxForm(options);
	$(formId).submit();
}

function receiverDataValidate(id, o){
	if(id!='' && id!=null){
		$('#'+id+' .errorBox').errorBox();
		// checkbox('#'+id);
		$('#'+id).validate({
			rules: {
				"firstName": {
					required:true,
					minlength: 2,
					firstname: true
				},
				"lastName":{
					required:true,
					minlength: 2,
					surname: true
				},
				"phone":{
					phone: true,
					required: true
				}
			},
			messages: {
				"firstName":{
					required: "Podaj imię",
					minlength: "Imię jest za krótkie"
				},
				"lastName":{
					required: "Podaj nazwisko",
					minlength: "Nazwisko jest za krótkie"
				},
				"phone": {
					minlength: "Podaj numer telefonu",
					required: "Podaj poprawny numer telefonu"
				}
			}
		});
	}
}

function setESDPopup() {
	$('.js-esd-print').on('click', function (event) {
		$.fancybox({
			href: $(this).attr('href')
		}, {
			type: 'iframe',
			width: 980,
			height: 480
		});
		event.preventDefault();
	});

	$('.js-show-esd-code').on('click', function (event) {
		$.fancybox({
			href: '/' + 'customer-esd-codes.ltr?orderNumber=' + $(this).data('order-number') + '&orderItemId=' + $(this).data('order-item-id')+ '&orderType=' + $(this).data('order-type')
		}, {
			autoDimensions: true,
			onComplete: function onComplete(e) {
				$('#esd-modal .esd-code').on('blur', function () {
					$(this).attr('disabled', true).val($(this).data('code'));
				});
			}
		});

		event.preventDefault();
	});

	var esdClipboard = new Clipboard('.js-esd-to-clipboard');

	esdClipboard.on('success', function (e) {
		console.log($(e.trigger));
		$(e.trigger).addClass('copied');

		setTimeout(function () {
			$(e.trigger).removeClass('copied');
		}, 1500);

		e.clearSelection();
	});

	esdClipboard.on('error', function (e) {
		var inpudCodeTarget = $($(e.trigger).data('code-element'));
		inpudCodeTarget.attr('disabled', false);

		e.clearSelection();
		inpudCodeTarget.focus().select();
	});
}

function copyToClipboard(elementId) {
	$el = $('#' + elementId)[0];
	$el.select();
	try {
		document.execCommand('copy');
	} catch (err) {
		console.log('Błąd execCommand');
	}
}